module["exports"] = ["#{Name.first_name}#{street_suffix}", "#{Name.last_name}#{street_suffix}"];